export default __webpack_public_path__ + "static/media/users-phone.a7250c16.png";